import {ChangeDetectionStrategy, Component, Inject, OnInit, Optional, PLATFORM_ID, signal} from '@angular/core'
import {RESPONSE} from '../../../../../server/express.tokens'
import type {Response} from 'express'
import {isPlatformServer} from '@angular/common'
import {LinkService} from '../../../core/i18n/link.service'
import {ActivatedRoute} from '@angular/router'
import {ErrorType} from './error.types'
import {OptableLayout} from '../../../core/components/layout/optable-layout.interface'
import {EPHEMERAL_404} from '../../../../../server/status'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'

@Component({
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent implements OnInit, OptableLayout {
  readonly error = signal(ErrorType.UNKNOWN)
  readonly ErrorType = ErrorType

  optOutOfLayout = false

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Record<string, unknown>,
    @Optional() @Inject(RESPONSE) private readonly response: Response,
    private readonly route: ActivatedRoute,
    public readonly linkService: LinkService,
  ) {
    this.route.data.pipe(takeUntilDestroyed()).subscribe(data => {
      if (data.error) {
        this.error.set(data.error)
      }
    })
  }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId) && this.response) {
      // set the http status code to 404 for better SEO (avoid soft 404)
      this.response.status(EPHEMERAL_404)
    }
  }
}
